import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CircleCheck, CircleAlert, TestTube } from "lucide-react";

export default function AdminHosts() {
  const [hosts, setHosts] = useState([]);
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState("");

  const load = () => api.get("/admin/hosts").then(r => setHosts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (host, on) => {
    setBusy(host.id); setErr("");
    try {
      await api.post(`/admin/hosts/${host.id}/mock-connect`, { enabled: on });
      await load();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed");
    } finally { setBusy(null); }
  };

  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-10">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="admin-hosts-title">Hosts</h1>
      <div className="mt-2 p-4 rounded-2xl bg-slate-50 border border-slate-200 text-sm text-slate-600 flex items-center gap-3">
        <TestTube size={16} className="text-slate-500"/>
        Test-mode toggle: mark a host as Stripe-Connect-ready without going through real onboarding. Only visible in non-production environments.
      </div>

      <div className="mt-6 space-y-3">
        {hosts.length === 0 && <div className="text-sm text-slate-500 p-6 border border-dashed border-slate-200 rounded-2xl" data-testid="admin-hosts-empty">No hosts yet.</div>}
        {hosts.map(h => (
          <div key={h.id} className="border border-slate-200 rounded-2xl p-5 bg-white flex items-center justify-between flex-wrap gap-4" data-testid={`admin-host-${h.id}`}>
            <div>
              <div className="font-semibold text-[var(--fpn-navy)]">{h.first_name} {h.last_name}</div>
              <div className="text-sm text-slate-500">{h.email} · {h.listing_count} listing{h.listing_count === 1 ? "" : "s"}</div>
              {h.stripe_account_id && <div className="text-xs text-slate-400 font-mono mt-1">{h.stripe_account_id}</div>}
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-xs font-semibold inline-flex items-center gap-1 px-2 py-1 rounded-md border ${h.stripe_charges_enabled ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-slate-50 text-slate-600"}`}>
                {h.stripe_charges_enabled ? <CircleCheck size={12}/> : <CircleAlert size={12}/>}
                {h.stripe_charges_enabled ? "Connect ready" : "Not connected"}
              </span>
              <button
                onClick={() => toggle(h, !h.stripe_charges_enabled)}
                disabled={busy === h.id}
                className={`text-sm rounded-full px-4 py-2 border ${h.stripe_charges_enabled ? "border-slate-200 text-slate-700" : "btn-amber"}`}
                data-testid={`admin-host-toggle-${h.id}`}
              >
                {busy === h.id ? "…" : h.stripe_charges_enabled ? "Disconnect (test)" : "Mark Connect-ready (test)"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {err && <div className="text-sm text-red-600 mt-4" data-testid="admin-hosts-error">{err}</div>}
    </div>
  );
}
